export default __webpack_public_path__ + "f776c2f82dd7b8523510e755c7e05998.png";